import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ic-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent implements OnInit {
  public headerTitle: string;
  public message: string;
  @Input() dialogData: any;

  constructor(
    public readonly activeDialog: NgbActiveModal,
  ) {}

  ngOnInit() {
    this.headerTitle = this.dialogData.header;
    this.message = this.dialogData.message;
  }
  onOk() {
    this.activeDialog.close(true);
  }
  onCancel() {
    this.activeDialog.close(false);
  }
}
